import { SuggestionItem } from './SuggestionItem'
import React from 'react'

export function Suggestions({ suggestions, onClick, adminSiteIds, usesAdvancedSiteManagement }) {
  return (
    <>
      <div role='table' className='search-results position-absolute'>
        <caption>{suggestions.title}</caption>
        <div role='rowgroup'>
          <div role='row' className='visually-hidden'>
            <div role='columnheader'>Name</div>
            <div role='columnheader'>Details</div>
            <div role='columnheader'>Actions</div>
            <div role='columnheader'>Locked</div>
          </div>
          {suggestions.results.map((person, idx) => (
            <SuggestionItem
              key={idx}
              person={person}
              position={idx + 1}
              adminSiteIds={adminSiteIds}
              usesAdvancedSiteManagement={usesAdvancedSiteManagement}
              onClick={onClick}
            />
          ))}
        </div>
      </div>
    </>
  )
}
